/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: ClickOutside.ts
 * Class: ClickOutside.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};
